import { NgModule, Optional, SkipSelf, APP_INITIALIZER } from '@angular/core';

import { ApiService } from './services/api.service';
import { FilteringService } from './services/filtering.service';
import { SettingsService } from './services/settings.service';
import { SweetAlertService } from './services/sweet-alert.service';
import { ThemesService } from './services/themes.service';
import { MenuService } from './services/menu.service';

import { throwIfAlreadyLoaded } from './module-import.guard';
import { LoginRequiredGuard } from './login-required.guard';
import { EndpointResolverService } from './services/endpoint-resolver.service';
import { OAuthService } from 'angular-oauth2-oidc';
import { endPointResolverInitializer } from './initializers/endpoint-resolver-initializer';
import { OauthServiceInitializer } from './initializers/oauth-service-initializer';
import { Router } from '@angular/router';
import { SignalrService } from './services/signalr-service.service';


@NgModule({
  imports: [
  ],
  providers: [
    ApiService,
    EndpointResolverService,
    FilteringService,
    MenuService,
    SettingsService,
    SweetAlertService,
    ThemesService,
    LoginRequiredGuard,
    SignalrService,
    {
      provide: APP_INITIALIZER,
      useFactory: endPointResolverInitializer,
      deps: [EndpointResolverService],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: OauthServiceInitializer,
      deps: [OAuthService, SettingsService, Router],
      multi: true,
    }
  ],
  declarations: [
  ],
  exports: [

  ]
})
export class CoreModule {
  constructor(@Optional() @SkipSelf() parentModule: CoreModule) {
    throwIfAlreadyLoaded(parentModule, 'CoreModule');
  }
}
